import persistence from '@/services/localstorage.service'

const install = (Vue) => {
  const vue = Vue
  vue.prototype.$persistence = persistence
}

export default { install }
